import Cookie from '@wetransfer/concorde-cookie';

const COOKIE_NAME = '__wtcm';
const COOKIE_EXPIRY_IN_DAYS = 182.5;

export function getTCStringFromCookie() {
  const tcString = Cookie.get(COOKIE_NAME);
  if (tcString === null) {
    return '';
  }
  return tcString;
}

export function setTCStringCookie(tcString) {
  Cookie.set(COOKIE_NAME, tcString, { days: COOKIE_EXPIRY_IN_DAYS });
}

const CCPA_COOKIE_NAME = '__wtccpa';

export function setCcpaStringCookie(ccpaString) {
  Cookie.set(CCPA_COOKIE_NAME, ccpaString, { days: COOKIE_EXPIRY_IN_DAYS });
}

export function getCcpaStringFromCookie() {
  const ccpaString = Cookie.get(CCPA_COOKIE_NAME);
  if (ccpaString === null) {
    return '';
  }
  return ccpaString;
}
